import React from 'react';
import { inject, observer } from 'mobx-react';

import "../../stylesheets/common.scss";

@inject('languageStore')
@observer
export default class Language extends React.Component {
  renderWithArgs = () => {
    const children = this.props.children
    const keys = this.props.keys
    let string = this.props.languageStore.getResource(this.props.languageStore.lang, this.props.resource)
    for (let i = 0; i < keys.length; i++) {
      let key = `{key-${i}}`
      if (typeof keys[i] === 'object') {
        string = string.replace(new RegExp(key,'g'), keys[i] && keys[i][this.props.languageStore.lang] ? keys[i][this.props.languageStore.lang] : '')
      } else {
        string =  string.replace(new RegExp(key,'g'), keys[i])
      }
    }
    return (
      <span className={
        this.props.className ? this.props.className : ''
      }>
      {string}
      {children && children}
      </span>
    );
  }
  render() {
    if (this.props.keys) {
      return this.renderWithArgs()
    }
    const children = this.props.children
    return (
      <span className={
        this.props.className ? this.props.className : ''
      }>
      {this.props.languageStore.getResource(this.props.languageStore.lang, this.props.resource)}
      {children && children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/language/language.js